import { atom } from 'jotai';

export type DataPopupPushNotifications = {
  show: boolean;
};

export const popupPushNotificationsAtom = atom<DataPopupPushNotifications>({
  show: false,
});
